import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-y-circle', 'LetterYCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 8.25l3 4m3-4-3 4m0 0v4","key":"svg-0"}]]);